import{scenarioTestTableActions} from './../constants';
export const addTestTableFromAPI = ( testData ) => {
    return {
        type: scenarioTestTableActions().addTestData,
        testData
    }
}

export const editTestTableData = ( testData ) => {
    return {
        type: scenarioTestTableActions().editTestData,
        testData
    }
}

export const deleteTestTableData = ( test_point_id ) => {
    return {
        // type: scenarioTestTableActions().deleteTestData,
        type: "DELETE_TEST_DATA",
        test_point_id
    }
}
